
import { footer } from '../customWhiteLabel'

export default {
  methods: {
    contatoAgendamento() {
      const phoneNumber = footer.whatsapp.replace(/\D/g, '')
      const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
        footer.messageAgendamento
      )}`
      window.open(whatsappUrl, '_blank')
    },
  },
}
